import React from 'react';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import logoDesktop from '../Images/logo.png';

import { Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  bar: {
    display: 'flex',
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  image: {
    position: 'relative',

    display: 'flex',
    justifyContent: 'flex-end',
    width: '11vh',
    marginRight: '2rem',
    height: '100%',
    // backgroundColor: theme.palette.grey[800],

    marginBottom: theme.spacing(4),
    backgroundImage: `url(${logoDesktop})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  logo: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex - end',
  },
  tabs: {
    [theme.breakpoints.down('xs')]: {
      padding: '8px 7px',
    },
  },
}));

const ToolbarComponent = () => {
  const classes = useStyles();
  let value = '';

  return (
    <React.Fragment>
      <AppBar className={classes.bar} position="static">
        <Tabs value={value} indicatorColor="secondary" textColor="secondary">
          <Tab
            key="0"
            value="Главная"
            className={classes.tabs}
            component={Link}
            label="Главная"
            to="/"
          />
          <Tab
            key="1"
            value="Продукт"
            className={classes.tabs}
            component={Link}
            label="Продукт"
            to="/product"
          />
          <Tab
            key="2"
            className={classes.tabs}
            component={Link}
            label="Контакты"
            to="/contact"
          />
          <div className={classes.icon}>
            <Link to="/">
              <Paper className={classes.image} noWrap />
            </Link>
          </div>
        </Tabs>
      </AppBar>
    </React.Fragment>
  );
};
export default ToolbarComponent;
